import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreRequestForInformationMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useRFITrackerContext } from '../../../../RFITrackerContext'
import { RequestForInformation } from '../../../../RFITrackerContext/types'

export function useRestoreOptions(): RestoreRowActionOptions<RequestForInformation> {
  const { refetch } = useRFITrackerContext()
  const [restore] = useRestoreRequestForInformationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreRequestForInformation: {
        requestForInformation: { formattedNumber },
      },
    }) => simpleRestoreNotification(formattedNumber),
  })
  return {
    permission: Permission.RemoveRestoreRequestForInformation,
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
